import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'ellipsis',
    standalone: false
})
export class EllipsisPipe implements PipeTransform {
  transform(value, numberOfChar: number): any {
    return value.length > numberOfChar ? value.substring(0, numberOfChar).concat('...') : value;
  }
}
